<template>
    <!--格式化表格中的cell，因为有些数据比较难格式化，如枚举，和需子表查询，如通过id显示名字-->

     <span class="formui-tablecell" >
        {{val||'—'}}
    </span>


</template>

<script>
  import mathUtil from './service/lib/math.js'
//  import router from '../../../../router'
  import formuiService from './service/formui/FormuiService.js'
  import moment from 'moment'
  export default {
    name: 'UIForm_form',
    props: ['beanName','fieldName','value'],
//    components:{ImgUploadOss,formUiStyleSelect,formUiForeignSelect,FormUiQueryParamItem,},
    data () {
      return {
        val:'',
        waitTimes:0

      }
    },
      watch : {
          value (newval,oldval){
//                console.log('-watch-'+oldval+''+newval)
//                return this.fieldItem
              let that=this
              setTimeout(function () {
                  that.waitLoad()
              },0)
            }
//
        },
    methods: {

        waitLoad:function(){
            let that=this
            let keyLoad='tablecell_v8_load_'+that.beanName+'_'+that.fieldName+'_'+that.value
            let key='tablecell_v8_'+that.beanName+'_'+that.fieldName+'_'+that.value

            let valLoad=sessionStorage.getItem(keyLoad);

            if(valLoad){
                //带锁中，重试几次
//                console.log(2222222222222222222222)

                if(that.waitTimes>5){
                    return;
                }
                setTimeout(function () {
                    that.waitTimes++
                    that.waitLoad()
                },500)

                return

            }
//            console.log(11111111111111111111111)
//alert(key)
            let val=sessionStorage.getItem(key);
//            alert(val)
            if(val||val===''||val===0){
                this.val=val
                return;
//            }else if(val===null){
////                this.val=''
//                return;
            }else{
                sessionStorage.setItem(keyLoad,1);
                formuiService.getFormUiTableCellValueStr(that,
                    {beanName:that.beanName,fieldName:that.fieldName,value:that.value}
                    ,function (resp) {
                        if(resp.formuiFieldValue||resp.formuiFieldValue===''||resp.formuiFieldValue===0){
                            that.val=resp.formuiFieldValue
                            sessionStorage.setItem(key,resp.formuiFieldValue);
                        }
                        sessionStorage.removeItem(keyLoad);
                    },function (err) {
                        sessionStorage.removeItem(keyLoad);
                    })
//
            }


        },

    },
    created(){
      let that=this

        this.waitLoad()


    },
    mounted () {
//      console.log('-----------mounted-------------')


    },

    updated () {
//    console.log('-----------updated-------------')
    },


  }
</script>

<style scoped="page">

</style>



// WEBPACK FOOTER //
// node_modules/formui-vue2-vistastory/FormUiTableCell.vue